module.exports = __webpack_public_path__ + "img/resource-tech-image-49.05308478.jpg";